<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('enrolments.title_org')"></page-header-title>

      <v-spacer></v-spacer>

      <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                :label="$t('enrolments.search')"
                v-model="search_params.any"
                @keydown="checkKeyPress"
                autocomplete="new-password"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <router-link
        :to="BACKEND_URL + '/enrolments/organisations/create'"
        v-if="$hasRole('system-developer') || $hasRole('organisation-admin')"
      >
        <action-button type="new" />
      </router-link>

      <action-button type="merge" :text="$t('enrolments.merge')" v-if="selected.length > 1" @click="showMergeModal = true" />

      <!--<router-link
                :to="BACKEND_URL + '/enrolments'"
                v-if="$can('enrolment-access')"
            >
                <action-button type="default" :text="$t('enrolments.title')" icon="how_to_reg" />
            </router-link>-->
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="organisations"
            :items-per-page="organisations.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :show-select="true"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            item-key="id"
            v-model="selected"
            :must-sort="true"
          >
            <template v-slot:item.actions="{ item }">
              <router-link
                :to="{ path: BACKEND_URL + '/enrolments/organisations/view/' + item.id, props: { id: item.id } }"
                v-if="$can('enrolment-access') || $can('companies-access')"
              >
                <action-button type="view" :icon_only="true" small />
              </router-link>

              <!--<action-button
                                type="delete"
                                :icon_only="true"
                                @click="del(item.id)"
                                v-if="$can('enrolment-delete')"
                                small
                            />-->
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showMergeModal" persistent max-width="70%">
      <v-card>
        <v-app-bar text color="secondary">
          <v-toolbar-title class="subheading">{{ $t("enrolments.merge_title") }}</v-toolbar-title>
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text class="py-0 mt-4">
          <v-container grid-list-md class="pa-0">
            <v-layout row wrap>
              <v-flex md12>
                <p class="ml-2">{{ $t("enrolments.merge_sub") }}</p>
              </v-flex>
              <v-flex md4 v-for="item in selected" v-bind:key="item.id" class="pa-2">
                <v-card
                  class="mx-auto card-org-merge"
                  height="100%"
                  :hover="true"
                  @click="setPrimaryOrg(item.id)"
                  :color="selectedPrimaryOrg == item.id ? 'primary' : ''"
                >
                  <v-card-text>
                    <div></div>
                    <p class="title text--primary">
                      {{ item.name }}
                    </p>
                    <div class="text--primary">
                      {{ item.vat }}<br />
                      {{ item.req_first_name }} {{ item.req_last_name }}<br />
                      {{ item.req_email }}<br />
                      {{ item.visiting_street }}<br />
                      {{ item.visiting_zip }} {{ item.visiting_city }}<br />
                      {{ item.visiting_country }}<br />
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <action-button type="merge" :text="$t('enrolments.merge')" @click="merge()" small />
          <action-button
            type="cancel"
            @click="
              showMergeModal = false
              selectedPrimaryOrg = null
            "
            small
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "EnrolmentsList",

  data() {
    return {
      url: "",
      organisations: [],

      selected: [],
      selectedPrimaryOrg: null,
      showMergeModal: false,

      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__enrOrganisationListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["name"],
        sortDesc: [false]
      },
      search_params: {
        any: "",
        title: ""
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("enrolments.o_name"), value: "name" },
          { text: this.$t("enrolments.o_vat"), value: "vat" },
          { text: this.$t("enrolments.o_address_zip"), value: "visiting_zip" },
          { text: this.$t("enrolments.o_address_country"), value: "visiting_country" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end" }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          localStorage.setItem("__enrolmentOrgListSearchParams", JSON.stringify(this.search_params))
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) || !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc
            }
            localStorage.setItem("__enrolmentOrgListSort", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__enrOrganisationListPage", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "enrolments/organisations"
    if (localStorage.getItem("__enrolmentOrgListSearchParams")) {
      this.search_params = JSON.parse(localStorage.getItem("__enrolmentOrgListSearchParams"))
    }
  },

  methods: {
    list() {
      this.show_loading = true

      let localSort = localStorage.getItem("__enrolmentOrgListSort")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then((res) => {
        this.organisations = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    filter(target) {
      this.pagination.page = 1
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "enrolment/organisation/" + id)
            .then((res) => {
              vm.refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    setPrimaryOrg(id) {
      this.selectedPrimaryOrg = id
    },

    merge() {
      let vm = this

      if (!vm.selectedPrimaryOrg) {
        vm.$awn.alert(vm.$t("enrolments.no_company_selected"))
        return
      }

      this.$awn.confirm(
        vm.$t("enrolments.merge_confirm"),
        () => {
          axios
            .post(this.API_URL + "enrolment/organisation/merge", {
              primary_orgid: vm.selectedPrimaryOrg,
              selected_orgid: vm.selected.map((a) => a.id).join(",")
            })
            .then((res) => {
              if (typeof res.data.errors !== "undefined") {
              } else {
                vm.$awn.success(vm.$t("enrolments.merge_success"))
                vm.refresh = true
                vm.showMergeModal = false
                vm.selectedPrimaryOrg = null
                vm.selected = []
              }
            })
            .catch((err) => console.log(err))
        },
        () => {
          return
        },
        {
          labels: {
            confirmOk: vm.$t("global.yes"),
            confirmCancel: vm.$t("global.no")
          }
        }
      )
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>
.card-org-merge.primary .text--primary {
  color: #fff !important;
}
</style>
